<template>
  <div class="rich-colorful">
    <div class="rich-colorful-title">
      <h1>设计的项目 丰富多彩</h1>
    </div>
    <div class="rich-colorful-content">
      <div class="common">
        <img src="../designImg/design01.png" alt="" />
        <h2>
          <span>更丰富</span>
        </h2>
        <p style="margin-top: 19px;">海量的实用项目</p>
        <p>丰富的案例内容</p>
        <p>多样的设计场景</p>
      </div>
      <div class="common">
        <img src="../designImg/design02.png" alt="" />
        <h2>
          <span>更有趣</span>
        </h2>
        <p style="margin-top: 19px;">项目活泼且有趣</p>
        <p>增设绘画与鉴赏</p>
        <p>培养兴趣与审美</p>
      </div>
      <div class="common">
        <img src="../designImg/design03.png" alt="" />
        <h2>
          <span>更易学</span>
        </h2>
        <p style="margin-top: 19px;">严格的知识点筛选</p>
        <p>合理的知识点架构</p>
        <p>保证精华吸收效果 </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "richColorful"
}
</script>

<style lang="scss" scoped>
  .rich-colorful {
    background: url("../designImg/web2x_fengfu.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    min-width: 1200px;
    height: 605px;
    background-color: #fff;
    margin: 0px auto;
    box-sizing: border-box;
    .rich-colorful-title {
      width: 100%;
      margin: 0 auto;
      padding-top: 72px;
      box-sizing: border-box;
      h1 {
        margin: 0 auto;
        min-width: 1200px;
        width: 1200px;
        text-align: center;
        font-size: 36px;
        // font-family: "Fontquan-qingkehuangyouti";
        font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
        font-weight: 400;
        color: #000000;
        line-height: 45px;
      }
      p {
        text-align: center;
        margin-top: 20px;
        color: #8e8e8e;
        font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
      }
    }
    .rich-colorful-content {
      margin: 0px auto;
      margin-top: 65px;
      padding-bottom: 40px;
      box-sizing: border-box;
      width: 1200px;
      height: 370px;
      display: flex;
      justify-content: space-between;
      .common {
        width: 382px;
        height: 347px;
        background-color: #fff;
        border: 1px solid #eee;
        box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.04);
        h2 {
          margin-top: 30px;
          width: 100%;
          font-size: 18px;
          // font-family:Fontquan-qingkehuangyouti;
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
          font-weight: 400;
          text-align: center;
          color: #343434;
          line-height: 25px;
          .span-color {
            color: #1286FF;
          }
          span {
            // font-family: Fontquan-qingkehuangyouti;
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
          }
        }
        p {
          margin-top: 10px;
          // font-family: Fontquan-qingkehuangyouti;
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
          opacity: 0.7;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          color: #343434;
          line-height: 13px;
          width: 100%;
        }
        img {
          display: block;
          width: 152px;
          margin: 20px auto;
        }
      }
    }
  }
</style>